import { html } from '@ni/fast-element';

export const template = html`<template slot="mapping"></template>`;
